export const managerSessionStorageKeys = {
  authenticated: 'spot_changes_authenticated',
  userName: 'spot_changes_user_name',
  pin: 'spot_changes_pin',
  token: 'spot_changes_token',
  tokenExpiry: 'spot_changes_token_expiry',
};

const canUseStorage = typeof window !== 'undefined';

const readSessionValue = (key) => {
  if (!canUseStorage) return null;
  return sessionStorage.getItem(key);
};

export const clearManagerSessionStorage = () => {
  if (!canUseStorage) return;
  Object.values(managerSessionStorageKeys).forEach((key) => {
    sessionStorage.removeItem(key);
  });
};

export const saveManagerSession = ({ userName, pin, token, tokenExpiresAt }) => {
  if (!canUseStorage) return;

  sessionStorage.setItem(managerSessionStorageKeys.authenticated, 'true');
  sessionStorage.setItem(managerSessionStorageKeys.userName, userName || 'Manager');

  if (pin) {
    sessionStorage.setItem(managerSessionStorageKeys.pin, pin);
  }

  if (token) {
    sessionStorage.setItem(managerSessionStorageKeys.token, token);
  }

  if (tokenExpiresAt) {
    sessionStorage.setItem(managerSessionStorageKeys.tokenExpiry, tokenExpiresAt);
  }
};

export const getManagerSessionSnapshot = () => {
  const isActive = readSessionValue(managerSessionStorageKeys.authenticated) === 'true';
  const name = readSessionValue(managerSessionStorageKeys.userName) || 'Manager';

  return { isActive, name };
};

export const hasManagerWriteSession = () => {
  const isActive = readSessionValue(managerSessionStorageKeys.authenticated) === 'true';
  const userName = readSessionValue(managerSessionStorageKeys.userName);
  const token = readSessionValue(managerSessionStorageKeys.token);
  const tokenExpiry = readSessionValue(managerSessionStorageKeys.tokenExpiry);

  if (!isActive || !userName || !token || !tokenExpiry) {
    return false;
  }

  const expiryMillis = Date.parse(tokenExpiry);
  if (!Number.isFinite(expiryMillis) || expiryMillis <= Date.now()) {
    clearManagerSessionStorage();
    return false;
  }

  return true;
};

export const getManagerToken = () => {
  if (!hasManagerWriteSession()) {
    return null;
  }

  return readSessionValue(managerSessionStorageKeys.token);
};
